import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label", "onClick", "sx"];
import * as React from 'react';
import { Box, Button, Toolbar, Typography, extendSX } from '@lumahealthhq/ui-core';
import { useIntl } from '../../../hooks';
import { usePaginationContext } from '../../contexts/PaginationContext';
import { useSearchContext } from '../../contexts/SearchContext';
import { useSelectedItems } from '../../contexts/SelectedItemsContext';
import SearchField from '../SearchField';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getNumSelected = selectedItems => Object.values(selectedItems).filter(item => !!item).length;
const getSelectedItemsArray = selectedItems => {
  const selectedItemsArray = Object.entries(selectedItems).filter(([, value]) => !!value).map(([key]) => key);
  return selectedItemsArray;
};

/**
 * @ignore - internal component.
 */
function TableToolbar(props) {
  var _withSearch$placehold;
  const {
    renderLabel,
    children,
    groupMenuOptions = [],
    withSearch,
    filterComponent
  } = props;
  const {
    selectedItems
  } = useSelectedItems();
  const {
    handleSearchInput
  } = useSearchContext();
  const {
    setPage
  } = usePaginationContext();
  const intl = useIntl();
  const numSelected = getNumSelected(selectedItems);
  const selectedItemsArray = getSelectedItemsArray(selectedItems);
  const label = renderLabel ? renderLabel(numSelected) : undefined;
  const resetPage = React.useCallback(() => setPage(0), [setPage]);
  const renderedFilter = React.useMemo(() => {
    if (!filterComponent) {
      return null;
    }
    if ( /*#__PURE__*/React.isValidElement(filterComponent)) {
      return /*#__PURE__*/React.cloneElement(filterComponent, {
        resetPage
      });
    }
    return filterComponent;
  }, [filterComponent, resetPage]);
  return /*#__PURE__*/_jsxs(Toolbar, {
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        alignItems: 'center',
        pr: 2
      },
      children: typeof label === 'string' ? /*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        sx: {
          whiteSpace: 'nowrap'
        },
        children: numSelected > 0 ? `${numSelected} ${intl.formatMessage({
          id: "LtTjKV",
          defaultMessage: [{
            "type": 0,
            "value": "selected"
          }]
        })}` : label
      }) : label
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'space-between',
        flexGrow: 1
      },
      children: [/*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          justifyContent: 'flex-start'
        },
        children: numSelected > 0 && groupMenuOptions.map((_ref, idx) => {
          let {
              label: actionLabel,
              onClick,
              sx
            } = _ref,
            actionItemProps = _objectWithoutPropertiesLoose(_ref, _excluded);
          const handleClick = e => {
            onClick == null ? void 0 : onClick(e, selectedItemsArray);
          };
          return /*#__PURE__*/_jsx(Button, _extends({
            onClick: handleClick,
            variant: idx === 0 ? 'primary' : 'secondary',
            sx: extendSX({
              whiteSpace: 'nowrap'
            }, sx)
          }, actionItemProps, {
            children: actionLabel
          }), `bulk-action-item-${idx + 1}`);
        })
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          justifyContent: 'flex-end',
          flexGrow: 1
        },
        children: [!numSelected && /*#__PURE__*/_jsxs(React.Fragment, {
          children: [children, withSearch ? /*#__PURE__*/_jsx(SearchField, {
            onChange: handleSearchInput,
            placeholder: (_withSearch$placehold = withSearch.placeholder) != null ? _withSearch$placehold : intl.formatMessage({
              id: "xmcVZ0",
              defaultMessage: [{
                "type": 0,
                "value": "Search"
              }]
            })
          }) : null]
        }), renderedFilter]
      })]
    })]
  });
}
export default TableToolbar;